import clearAuthToken from './clearAuthToken'
import clearCurrentUser from './clearCurrentUser'

const clearAllAuthentication = () => {
  clearAuthToken()
  clearCurrentUser()
}

export default clearAllAuthentication
